import {
  setCartCount,
  removeCartCount,
  getCartCount,
  incrementCartCount,
  isShowCartMerge,
  setShowCartMerge,
  removeShowCartMerge,
} from './storage';
export {
  setCartCount,
  removeCartCount,
  getCartCount,
  incrementCartCount,
  isShowCartMerge,
  setShowCartMerge,
  removeShowCartMerge,
};
